import { useRef, useState } from 'react'

import { setMessageFeedback } from '../../lib/assistant'

/** A judgement of this explanation alone; never a label on its source readings. */
export function MessageFeedback({ sessionId, messageId }: { sessionId: string; messageId: string }) {
  const [useful, setUseful] = useState<boolean | null>(null)
  const [pending, setPending] = useState(false)
  const busy = useRef(false)

  async function choose(value: boolean) {
    if (busy.current || useful === value) return
    busy.current = true
    setPending(true)
    try {
      await setMessageFeedback(sessionId, messageId, value)
      setUseful(value)
    } catch {
      // Keep the last saved answer and leave both choices available to retry.
    } finally {
      busy.current = false
      setPending(false)
    }
  }

  return (
    <div className="assistant-feedback" role="group" aria-label="Was this useful?" aria-busy={pending || undefined}>
      <span>Was this useful?</span>
      <button type="button" aria-pressed={useful === true} disabled={pending} onClick={() => void choose(true)}>Yes</button>
      <button type="button" aria-pressed={useful === false} disabled={pending} onClick={() => void choose(false)}>No</button>
    </div>
  )
}
